import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CustomCn } from '@gate31/core/src/libs/classname';
import { CardSetModalForm } from '@gate31/feature/CardSetModalForm/CardSetModalForm';
import { ModalOpts } from '@gate31/feature/Modal/Modal';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';

export class CardSetModalFormDesk extends CardSetModalForm {
    static cn = new Base.BuildCn('CardSetModalFormDesk');

    constructor(options: { template: keyof LiquidTemplates; modalTemplate: ModalOpts['template']; whenOpenModal?: (product: unknown) => void}) {
        super({
            template: options.template,
            modalTemplate: options.modalTemplate,
            cn: CardSetModalFormDesk.cn,
            productFormCn: new CustomCn('ProductFormDesk'),
            whenOpenModal: options.whenOpenModal
        });
    }
}
